import { TradingPanel } from '@trading-ui/core';
import { TradingDatagrid } from '@trading-ui/tables';
import { useTranslation } from 'react-i18next';

import TableLoader from '@/components/table-loader/TableLoader';

import type { Company } from '@/interfaces/app.interfaces';

import * as styles from './ActiveCompaniesTable.css';
import { useActiveCompaniesFilters } from './hooks/useActiveCompaniesFilters';

type Props = {
  columns: any[];
  data: Company[] | undefined;
  isLoading: boolean;
  isRefetching: boolean;
};

export default function ActiveCompaniesTable({ columns, data, isLoading, isRefetching }: Props) {
  const { t } = useTranslation();
  const { filtersTable } = useActiveCompaniesFilters();

  return (
    <TradingPanel className={styles.root}>
      <div className={styles.tableContainer}>
        {isLoading && !data ? (
          <TableLoader />
        ) : (
          <TradingDatagrid
            tableHeight="calc(55vh - 200px)"
            columnsTable={columns}
            stickyColumns={{
              name: 'left',
              delete: 'right',
            }}
            dataTable={data}
            filters={filtersTable}
            flexLayout
            keepSelectedRowsOnPageChange={false}
            columnOrder={columns.map((column) => column.accessor)}
            isLoadingMore={isRefetching}
            noDataMessage={isRefetching ? '' : t('settings.moeveActionsTab.activeCompanies.emptyMessage')}
          />
        )}
      </div>
    </TradingPanel>
  );
}
